<template>
  <div class="app-view coupon-page">
    <!-- 菜单栏（内嵌App时隐藏） -->
    <app-header :title="title" :to="to" />
    <!-- 优惠券列表 -->
    <div class="coupon_shadow-item" v-for="(item, index) in couponList" :key="index">
      <div
        class="coupon-item"
        :class="{
          invalid: item.invalid,
          activate: item.id === select.couponid
        }"
        @click="selectCoupon(item)"
      >
        <!-- 优惠券选择效果 -->
        <div class="coupon_choose">
          <div :class="selectIcons[item.id === select.couponid ? 1 : 0]"></div>
        </div>
        <!-- 优惠券内容 -->
        <div class="item-text">
          <div class="is-title">{{ item.discountName }}</div>
          <div class="is-desc">
            {{ `限${item.beginDate}至${item.endDate}使用` }}
          </div>
          <div class="is-desc" v-if="item.sourceType && item.sourceType == 'friend_gift'">
            用户{{ item.sourceId }}赠送
          </div>
          <div class="is-desc" v-if="item.sourceType && item.sourceType == 'order'">订单购买</div>
          <div class="is-desc" v-if="item.sourceType && item.sourceType == 'gift'">友邻赠送</div>
          <div class="is-desc" v-if="item.discountDesc == '全场通用'">
            {{ item.discountDesc }}
          </div>
          <div v-else>
            <div class="is-desc is-desc2" @click.stop="openRules(item)" v-if="showUseRule(item)">
              使用规则
              <img src="../../../images/icon/icon_bom.png" alt="" />
            </div>
            <div class="is-desc is-desc2" @click.stop="closeRules(item)" v-if="!showUseRule(item)">
              使用规则
              <img src="../../../images/icon/icon_up.png" alt="" />
            </div>
            <div class="" v-if="!showUseRule(item)">
              {{ item.useRule }}
            </div>
          </div>
        </div>
        <div class="border"></div>
        <div class="left"></div>
        <div class="right"></div>
        <!-- 优惠券折扣 -->
        <div class="item-price">
          <div class="is-title">
            <span v-if="item.type === 1">
              <span class="discount-text">{{ item.discountText }}</span>
              折
            </span>
            <span v-else>
              <span class="money">¥</span>
              <span class="discount-text">{{ item.discountText }}</span>
            </span>
          </div>
          <div class="is-range">{{ item.discountRange }}</div>
        </div>
      </div>
    </div>
    <!-- 使用优惠券 -->
    <form-button-buttom text="确认使用" size="normal" @click="setCoupon({ name: 'item' })">
      <template #label>
        <div class="coupon-select">
          已选用{{ select.count }}张，可抵扣
          <span class="price">¥{{ select.deduction }}</span>
        </div>
      </template>
    </form-button-buttom>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Body from '@/mixins/body'
// import { Toast } from 'mint-ui'
const parseDate = (moment, date) => moment(date).format('YYYY-MM-DD')
const componentName = 'coupons'
export default {
  name: componentName,
  componentName,
  mixins: [Body],
  data() {
    return {
      title: '优惠券',
      selectIcons: ['', 'selected'],
      // 选择的优惠券
      select: {
        count: 0, // 使用优惠券数量
        couponid: 0, // 默认使用的优惠券ID
        deduction: 0 // 抵扣金额
      },
      openRule: []
    }
  },

  computed: {
    ...mapGetters('payment/order', ['preOrder', 'coupon']),
    couponList() {
      const { preOrder } = this
      const { isEmpty, couponList } = preOrder

      // 没有订单，跳转到订单确认页
      if (isEmpty) {
        this.setCoupon({ name: 'item' })
        return []
      }
      return (couponList || []).map(item => {
        const { name, type, couponDiscount, maxAmount, albumList = [], content, limitAmount } = item
        const discountText = type === 1 ? content : content // 如果是折扣 50 转换为 5
        const discountDesc =
          (albumList.length ? `仅限${albumList.map(name => `《${name}》`).join('、')}可用` : '全场通用') +
          (maxAmount ? `，最多优惠${maxAmount}元` : '')
        return {
          type,
          id: item.id,
          couponDiscount, // 已计算好的优惠金额
          discountText,
          discountRange: limitAmount ? `满${limitAmount}可用` : '无使用门槛',
          discountName: name,
          useRule: item.useRule,
          sourceType: item.sourceType,
          sourceId: item.sourceId,
          beginDate: parseDate(this.$moment, item.effectiveStartTime),
          endDate: parseDate(this.$moment, item.effectiveEndTime),
          discountDesc, // 西南联大可用，最多优惠100元
          invalid: item.status === 0 // 失效状态不查下
        }
      })
    },
    showUseRule() {
      return function (item) {
        if (this.openRule.indexOf(item.id) == -1) {
          return true
        }
        return false
      }
    },
    goodsId() {
      return this.$route.query.orderId
    },
    orderId() {
      return this.$route.query.orderId
    },
    to() {
      return {
        name: 'confirmOrder',
        params: { id: this.orderId }
      }
    }
  },
  created() {
    this.selectCoupon()
  },
  watch: {
    couponList(newVal) {
      this.selectCoupon()
    }
  },
  activated() {
    const { coupon: item, select } = this
    // 取消优惠券，但是没有保存，还原选择状态
    if (item.id) {
      select.count = 1
      select.couponid = item.id
      select.deduction = item.couponDiscount
    } else {
      select.count = 0
      select.couponid = 0
      select.deduction = 0
    }
  },
  methods: {
    // 设置优惠券
    selectCoupon(item) {
      const { select } = this
      // 如果已经选择了优惠券，点击取消选择
      if (item && item.id === select.couponid) {
        this.cancelCoupon(item)
        return
      }
      // 选择默认优惠券
      if (item == null) {
        item = this.couponList.filter(item => !item.invalid).shift()
      }
      if (item == null) {
        return
      }
      if (item.invalid) {
        return
      }
      // 计算优惠券金额
      select.count = 1 // 使用优惠券数
      select.couponid = item.id
      select.deduction = item.couponDiscount
    },
    cancelCoupon() {
      const { select } = this
      // 计算优惠券金额
      select.count = 0 // 使用优惠券数
      select.couponid = 0
      select.deduction = 0
    },
    // 列表事件
    setCoupon(action) {
      // 选择优惠券
      if (action.name === 'item') {
        // const id = this.orderId
        const { couponid } = this.select
        // 可以不使用优惠券
        // if (!id || !couponid) {
        //   Toast('请选择优惠券')
        //   return
        // }
        const item = this.preOrder.couponList.find(c => c.id === couponid)
        // 选择地址，返回订单页面
        this.$store.commit('payment/order/setCoupon', item || {})
        this.$router.back()
      }
    },
    openRules(item) {
      var index = this.openRule.indexOf(item.id)
      if (index == -1) {
        this.openRule.push(item.id)
      }
      console.log('this.openrule', this.openRule)
    },
    closeRules(item) {
      var index = this.openRule.indexOf(item.id)
      if (index != -1) {
        this.openRule.splice(index, 1)
      }
      console.log('this.openrule', this.openRule)
    }
  }
}
</script>

<style lang="scss">
.body-coupons {
  background-color: #f7f9fb;
}
</style>
<style lang="scss" scoped>
.coupon-page {
  padding-bottom: 1.5rem;
  background: #f1f2f3;
  height: 100%;
  overflow: auto;
  // 付款按钮
  .form-bottom-button.form-bottom-label {
    background-color: #f7f9fb;
    border-top: 1px solid #eeeeee;
    font-size: 0.28rem;
    // 优惠券使用
    .coupon-select {
      color: #666666;
      text-align: left;
      .price {
        color: #e65c53;
      }
    }
  }
  // 优惠券项
  .coupon_shadow-item {
    // background: url("../../../images/payment/coupon_shadow.png") no-repeat;
    background-size: 100% 100%;
    margin: 0.48rem;
  }
  .coupon-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.46rem 0.3rem 0.46rem 0.46rem;
    // background: url("../../../images/payment/coupon_board.png") no-repeat;
    background-size: 100% 100%;
    position: relative;
    color: #00b25a;
    width: 6.54rem;
    min-height: 2.54rem;
    background: #fff;
    border-radius: 0.16rem;
    .coupon_choose {
      background: url('../../../images/payment/coupon_choose.png') no-repeat;
      background-size: 100% 100%;
      width: 0.64rem;
      height: 0.64rem;
      position: absolute;
      right: 0px;
      top: 0px;
      .selected {
        background: url('../../../images/payment/coupon_choose_select.png') no-repeat;
        background-size: 100% 100%;
        width: 0.24rem;
        height: 0.24rem;
        border-radius: 50%;
        position: absolute;
        right: 0.15rem;
        top: 0.16rem;
      }
    }
    // 选择
    .item-value {
      text-align: right;
      .iconcircle-selected {
        color: #00b25a;
      }
    }
    &.invalid {
      opacity: 0.4;
    }
    // 选中效果
    &.activate {
      color: #00b25a;
      .iconcircle-selected {
        color: #00b25a;
      }
    }
    // 优惠券折扣
    .item-price {
      width: 2rem;
      font-size: 0.24rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: start;
      // padding-left: .5rem;
      margin: 0 auto;
      .money {
        margin-left: 0.08rem;
      }
      .discount-text {
        font-size: 0.56rem;
        margin-right: 0.08rem;
      }
      .is-title {
        font-weight: bold;
        margin-bottom: 0.2rem;
      }
      .is-range {
        font-size: 0.24rem;
        line-height: 0.3rem;
      }
    }
    .border {
      height: 100%;
      position: absolute;
      top: 0;
      right: 2.39rem;
      border-right: 1px dashed #eeeeee;
    }
    .left {
      width: 0.4rem;
      height: 0.4rem;
      border-radius: 50%;
      position: absolute;
      left: -0.2rem;
      top: 0;
      bottom: 0;
      margin: auto;
      background: #f1f2f3;
    }
    .right {
      width: 0.4rem;
      height: 0.4rem;
      border-radius: 50%;
      position: absolute;
      right: -0.2rem;
      top: 0;
      bottom: 0;
      margin: auto;
      background: #f1f2f3;
    }
    // 优惠券名字
    .item-text {
      flex: 1;
      // border-left: solid 1px #e7e7e6;
      // padding-left: .5rem;
      text-align: left;
      font-size: 0.2rem;
      line-height: 0.34rem;
      color: #999999;
      padding-right: 0.28rem;
      .is-title {
        color: #000000;
        font-weight: bold;
        font-size: 0.32rem;
        line-height: 0.45rem;
        margin-bottom: 0.16rem;
      }
      .is-desc {
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        line-height: 0.38rem;
      }
      .is-desc2 {
        display: flex;
        align-items: center;
        img {
          width: 0.16rem;
          height: 0.1rem;
          margin-left: 0.08rem;
          display: block;
        }
      }
    }
  }
}
</style>
